import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";
import SearchParams from "../searchParams";

export const superadmin = (api: API) => ({
  getSuperadmins(
    success: (data: OpenAPI.GET<"/superadmin/users">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("GET", "/superadmin/users", null, success, fail);
  },
  genData(
    data: OpenAPI.POST<"/superadmin/gen/data">["requestBody"],
    success: (data: OpenAPI.POST<"/superadmin/gen/data">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/gen/data",
      data,
      success,
      fail,
    );
  },
  removeGenData(
    success: (data: OpenAPI.DELETE<"/superadmin/gen/data">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      "/superadmin/gen/data",
      null,
      success,
      fail,
    );
  },
  sendEmail(
    data: OpenAPI.POST<"/superadmin/email">["requestBody"],
    success: (data: OpenAPI.POST<"/superadmin/email">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("POST", "/superadmin/email", data, success, fail);
  },
  getApiQuota(
    success: (data: OpenAPI.GET<"/superadmin/api">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("GET", "/superadmin/api", null, success, fail);
  },
  forceCrash(
    data: OpenAPI.POST<"/superadmin/developers/crash">["requestBody"],
    success: (
      data: OpenAPI.POST<"/superadmin/developers/crash">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/developers/crash",
      data,
      success,
      fail,
    );
  },
  getGlobalSettings(
    success: (data: OpenAPI.GET<"/superadmin/settings">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      "/superadmin/settings",
      null,
      success,
      fail,
    );
  },
  updateGlobalSettings(
    data: OpenAPI.POST<"/superadmin/settings">["requestBody"],
    success: (data: OpenAPI.POST<"/superadmin/settings">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      "/superadmin/settings",
      data,
      success,
      fail,
    );
  },
  allChallenges(
    params: OpenAPI.GET<"/superadmin/challenges">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/superadmin/challenges">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params).toString();
    api.authenticatedRequest(
      "GET",
      `/superadmin/challenges?${queryParams}`,
      null,
      success,
      fail,
    );
  },
  allIdeas(
    params: OpenAPI.GET<"/superadmin/ideas">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/superadmin/ideas">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params).toString();
    api.authenticatedRequest(
      "GET",
      `/superadmin/ideas?${queryParams}`,
      null,
      success,
      fail,
    );
  },
  getAnalytics(
    params: OpenAPI.GET<"/superadmin/analytics">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/superadmin/analytics">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params).toString();
    api.authenticatedRequest(
      "GET",
      `/superadmin/analytics?${queryParams}`,
      null,
      success,
      fail,
    );
  },
  indexOrganisationSearchContent(
    orgId: string,
    success: (
      data: OpenAPI.POST<"/superadmin/organisations/{id}/index-search">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/superadmin/organisations/${orgId}/index-search`,
      null,
      success,
      fail,
    );
  },
});
